import React, {useEffect, useState} from "react";
import styles from "./LandingPage.module.css";
import {Box, CircularProgress, Container, Grid} from "@mui/material";
import Logo from "../../assets/logo";
import VisualizzazioneAnonima from "./VisualizzazioneAnonima";
import {useNavigate, useParams} from "react-router-dom";
import {toast_error} from "../../utils/custom-toast";
import {ToastContainer} from "react-toastify";
import {useTranslation} from "react-i18next";
import {AuthApiService} from "../../services/AuthApiService";
import {IAuthGroup, IValidateTenant} from "../../types/auth";

const LandingPage: React.FC = () => {
	const {tenant} = useParams();
	const {t} = useTranslation();
	const [tenantName, setTenantName] = useState<string>("");
	const [tenantDisplayName, setTenantDisplayName] = useState<string|undefined>();
	if (tenant) {
		sessionStorage.setItem("tenant", tenant);
	}
	const navigate = useNavigate();

	const [isLoading, setIsLoading] = useState(true);
	const authApiService = new AuthApiService();

	useEffect(() => {
		const checkTenant = async () => {
			const requestbody: IValidateTenant = {
				code: tenant ?? '',
			};
			try {
				const response = await authApiService.validateTenant<IAuthGroup & { displayName?:string } >(requestbody);
				if (response) {
					if (response.name) {
						setTenantName(response.name);
						setTenantDisplayName(response.displayName);
						sessionStorage.setItem("tenantName", response.name);
					}
					setIsLoading(false);
				} else {
					navigate("*");
				}
			} catch (error: any) {
				navigate("*");
				toast_error(error);
			}
		};
		checkTenant();
	}, [navigate, tenant]);

	return (
		<>
			<ToastContainer />
			{isLoading ? (
				<div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
					<CircularProgress />
				</div>
			) : (
				<div>
					<Grid container className={styles.container}>
						<Grid item xs={12} sm={6} className={styles.primarySide}>
							<Container>
								<div className={styles.titleContainer}>
									<h1 className={`${styles.title} text-default-black`}>whistlebase</h1>
								</div>
							</Container>
						</Grid>
						<Grid item xs={12} sm={6} className={styles.whiteSide}>
							<Container maxWidth="sm">
								{/* <ColorChangerButton /> */}
								<Box marginBottom={"200px"}>
									<Logo width="60%" fill="#EEEEEE" />
								</Box>
								<div className={styles.labels}>{t("LANDINGPAGE.LABEL_SEND_REPORT", {tenantName: tenantDisplayName ? tenantDisplayName : tenantName })}</div>
								<VisualizzazioneAnonima />
							</Container>
						</Grid>
					</Grid>
				</div>
			)}
		</>
	);
};
export default LandingPage;
